import {
  Item,
  ItemGroup,
  SelectorProps,
  useSelector,
} from "@/app/providers/selector_provider"
import { useUserStore } from "@/app/providers/user_provider"
import { Button } from "@/components/buttons/button"
import { user_menu_options } from "@/components/settings"
import { UserMenuFooter } from "@/components/user/user.selector_footer"
import { UserMenuHeader } from "@/components/user/user.selector_header"
import { useGrowthBook } from "@growthbook/growthbook-react"
import { User } from "@phosphor-icons/react"
import { useRouter } from "next/router"

export type AvatarButtonProps = {
  className?: string
}

export function AvatarButton({ className }: AvatarButtonProps) {
  const growthbook = useGrowthBook()

  const { showSelector, isSelectorShown } = useSelector()
  const { push, pathname } = useRouter()

  const user = useUserStore((store) => store.user)

  function onSelect(newOption: string | null) {
    if (newOption == null) return

    push(newOption)
  }

  const menuOptions: Item[] = user_menu_options
    .filter((item) => {
      if (item.flagKey.length === 0 || growthbook.isOn(item.flagKey))
        return item
    })
    .map((item) => ({
      key: item.path,
      text: item.name,
      infoText: "",
      disabled: false, // all disabled options are controlled and filtered by growthbooks flag
    }))

  const userMenuSelector: SelectorProps = {
    selectedKey: pathname,
    options: [
      {
        disabled: true,
        key: "",
        text: "User Menu",
        items: menuOptions,
      } as ItemGroup,
    ],
    onSelect,
    header: <UserMenuHeader />,
    footer: <UserMenuFooter />,
  }

  return (
    <>
      <Button
        disabled={isSelectorShown}
        onClick={() =>
          user ? showSelector(userMenuSelector) : push("/auth/login")
        }
        className={`${className} print:hidden`}
        color="tertiary">
        {user && user.firstName && user.lastName ?
          <p className="text-sm font-bold">
            {user.firstName.slice(0, 1).toUpperCase()}
            {user.lastName.slice(0, 1).toUpperCase()}
          </p>
        : <User strokeWidth={2} width={30} className="w-5" />}
      </Button>
    </>
  )
}
